import moment from 'moment';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStateHandlers from 'recompose/withStateHandlers';
import withHandlers from 'recompose/withHandlers';
import DownloadModal from './components/DownloadModal';
import {
  getShop,
  isBrandViewActive,
  getActiveBrandId,
} from '../../../auth/selectors';
import config from '../../../../config';
import withNotifications from '../../../common/withNotifications';
import withDefaultEndingDate from '../filters/containers/withDefaultEndingDate';

const dateValidator = (start, end) => {
  if (!(end.diff(start, 'days') >= 6 || end.diff(start, 'days') === 0)) {
    return 'Difference between start and end date must be 1 day, 7 days or more.';
  }
  return '';
};

const mapStateToProps = (state, ownProps) => ({
  shop: getShop(state),
  timezone: state.auth.timezone,
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
  brand: getActiveBrandId(state),
  isBrandView: isBrandViewActive(state),
  dateRangeValidator: ownProps.dateRangeValidator || dateValidator,
});

export default compose(
  connect(mapStateToProps),
  withNotifications,
  withStateHandlers(props => ({
    startDate: props.startDate,
    endDate: props.endDate,
  }), {
    onDateChange: () => (startDate, endDate) => ({ startDate, endDate }),
  }),
  withHandlers({
    download: ({
      shop,
      startDate,
      endDate,
      timezone,
      close,
      addNotification,
      brand,
      isBrandView,
      shopAction,
      brandAction,
      dateRangeValidator,
    }) => () => {
      const start = moment.tz(startDate, config.dateFormat, timezone).startOf('day');
      const end = moment.tz(endDate, config.dateFormat, timezone).endOf('day');
      const errorMessage = dateRangeValidator(start, end);
      if (errorMessage) {
        return addNotification({ message: errorMessage });
      }

      if (isBrandView) {
        return brandAction(brand, start.toJSON(), end.toJSON(), timezone)
          .then(() => close());
      }
      return shopAction(shop, start.toJSON(), end.toJSON(), timezone)
        .then(() => close());
    },
  }),
  withDefaultEndingDate(),
)(DownloadModal);
